export const PTO_CONFLICT_TYPE = 'not-enough-pto-hours';

export class PtoConflictError extends Error {
  constructor(data) {
    super(data.message);
    this.name = 'PtoConflictError';
    this.ptoConflict = data;
  }
}

export const getPtoConflict = (error) =>
  error?.ptoConflict ||
  (error?.response?.data?.type === PTO_CONFLICT_TYPE ? error.response.data : null);

export const throwIfPtoConflict = (error) => {
  if (error?.response?.data?.type === PTO_CONFLICT_TYPE) {
    throw new PtoConflictError(error.response.data);
  }
};
